export default function OutlinedInput(theme) {
  return {
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          // padding: "2px !important",
        },
        input: {
          borderRadius: 12,
        },
        notchedOutline: {
          borderColor: "transparent !important",
        },
      },
    },
  };
}
